exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".blocking {\r\n\tcolor: #a94442;\r\n\tfont-weight: normal;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/anomalie/anomalie.component.css
// module id = 314
// module chunks = 0